import { render, staticRenderFns } from "./SummaryKuesioner.vue?vue&type=template&id=c3271d98&"
import script from "./SummaryKuesioner.vue?vue&type=script&lang=js&"
export * from "./SummaryKuesioner.vue?vue&type=script&lang=js&"
import style0 from "./SummaryKuesioner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports